  import { BrowserRouter, Routes, Route } from "react-router-dom";
  import "./App.css"; 
  import Home from "./home_page";
  import Research from "./Research";
  import Products from "./Products";
  import Patents from "./Patents";
  import About from "./About";
  import Generative from "./Generative";
  import Regulators from "./Regulators";
  import AI_Doctor from "./AI Doctor";
  import Economic_Research from "./Economic_Research";
  import Digital_Brain_Research from "./Digital_Brain_Research";
  import Main from "./ScrollToTop";
  import Doctor from "./Doctor";
  import Analyst from "./Analyst";
  import Lawyer from "./Lawyer";
  import Teacher from "./AI_Teacher";

  function App() {
    return (
      <BrowserRouter>
        <Main />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/research" element={<Research />} />
          <Route path="/Economic-Research" element={<Economic_Research />} />
          <Route path="/Digital_Brain_Research" element={<Digital_Brain_Research />} />
          <Route path="/products" element={<Products />} />
          <Route path="/patents" element={<Patents />} />
          <Route path="/generative" element={<Generative />} />
          <Route path="/about" element={<About />} />
          <Route path="/regulators" element={<Regulators />} />
          <Route path="/ai_doctor" element={<AI_Doctor />} />
          <Route path="/doctor" element={<Doctor />} />
          <Route path="/analyst" element={<Analyst />} />
          <Route path="/lawyer" element={<Lawyer />} />
          <Route path="/teacher" element={<Teacher />} />
        </Routes>
      </BrowserRouter>
    );
  }

  export default App;